/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {UpdateTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const updateTile = (request: UpdateTileRequest, options?: CashRequestOptions) => post<UpdateTileRequest, UpdateTileResponse>("/2.0/cash/update-tile", request, {...options, rejectOnError: true })